/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Created/view.blocks to change it.
import AccessKey from './AccessKey/index'
import AccessSecret from './AccessSecret/index'
import OkAction from './OkAction/index'
import React from 'react'
import TysiaModalContent from 'DesignSystem/TysiaModal/TysiaModalContent/index'
import TysiaModalFooter from 'DesignSystem/TysiaModal/TysiaModalFooter/index'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Created({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectDevelopers/CreateToken/Content/Created"
  
}) {
  return (<React.Fragment
>
<TysiaModalContent
  viewPath={`${viewPath}/TysiaModalContent`}
>
{childProps => (
<React.Fragment>
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 text="Please copy and save the following credentials. You won't be able to see this again."
/>
<AccessKey
{...childProps}
  viewPath={`${viewPath}/AccessKey`}
/>
<AccessSecret
{...childProps}
  viewPath={`${viewPath}/AccessSecret`}
/>
</React.Fragment>
)}
</TysiaModalContent>
<TysiaModalFooter
  viewPath={`${viewPath}/TysiaModalFooter`}
>
{childProps => (
<OkAction
{...childProps}
  viewPath={`${viewPath}/OkAction`}
/>
)}
</TysiaModalFooter>
{children}
</React.Fragment>)
}